import axios from "axios";
import Qs from "qs";
import { handleErrorResponse } from "@utils/errorLogger";
import { API_URL, API_URL_V2 } from "@constants";
import MicrosoftAuthenticationService from "./MicrosoftAuthenticationService";
import { throwIfNetworkError } from "../utils/network";

const http = axios.create();
http.interceptors.response.use(res => res, handleErrorResponse);
const coreFlag = localStorage.getItem("coreFlag") === "true";

const { getToken } = MicrosoftAuthenticationService;

export default class AbstractService {
	static get(params) {
		return this.request({
			...params,
			method: "GET",
		});
	}

	static post(params) {
		return this.request({
			...params,
			method: "POST",
		});
	}

	static put(params) {
		return this.request({
			...params,
			method: "PUT",
		});
	}

	static del(params) {
		return this.request({
			...params,
			method: "DELETE",
		});
	}

	static async request(req) {
		const {
			method = "GET",
			data,
			endpoint: url,
			responseType,
			getCancelToken,
			abortSignal,
			queryParams: params,
			isV2API = false,
			baseURL = isV2API ? API_URL_V2 : API_URL,
			headers = {},
			withCredentials = false,
			paramsSerializer = p => Qs.stringify(p, { arrayFormat: "repeat" }),
			cache,
			updateCache = false,
			allowAnonymous = false,
		} = req;
		const requestHeaders = { ...headers };
		const useToken = baseURL === API_URL || baseURL === API_URL_V2;

		if (!allowAnonymous && useToken) {
			const authToken = await getToken();

			requestHeaders.Accept = "application/vnd.rollkall.v6+json";
			requestHeaders.Authorization = `Bearer ${authToken}`;
		}

		if (coreFlag) {
			requestHeaders["x-force-to-core"] = "true";
		}

		const config = {
			baseURL,
			params,
			method,
			withCredentials,
			responseType,
			paramsSerializer,
			headers: requestHeaders,
			cancelToken: getCancelToken ? new axios.CancelToken(getCancelToken) : undefined,
			signal: abortSignal,
			cache,
			updateCache,
		};

		const globalCatch = (error) => {
			throwIfNetworkError(error);


			throw error;
		};

		switch (method) {
			case "POST":
				return http.post(url, data, config).catch(globalCatch);
			case "PUT":
				return http.put(url, data, config).catch(globalCatch);
			case "PATCH":
				return http.patch(url, data, config).catch(globalCatch);
			case "DELETE":
				return http.delete(url, { ...config, data }).catch(globalCatch);
			case "GET":
			default:
				return http.get(url, config).catch(globalCatch);
		}
	}
}
